// useAudioPrefs — thin React wrapper around the AudioManager singleton.
//
// Keeps audio logic OUT of components: the hook only mirrors the manager's prefs
// into render state and forwards toggle intents to the manager (which owns all
// playback + localStorage persistence). No Howl, no localStorage, no audio
// decisions live here.
import { useCallback, useState } from 'react';
import audioManager from '../lib/audioManager';

export default function useAudioPrefs() {
  const [prefs, setPrefs] = useState(() => audioManager.getPrefs());

  // After any manager mutation, re-read the canonical prefs so the UI reflects
  // exactly what the manager (and localStorage) now holds.
  const sync = useCallback(() => setPrefs(audioManager.getPrefs()), []);

  const toggleMute = useCallback(() => {
    audioManager.setMuted(!audioManager.getPrefs().muted);
    sync();
  }, [sync]);

  const setBgmBiome = useCallback((value) => {
    audioManager.setBgmBiomeEnabled(value);
    sync();
  }, [sync]);

  const setBgmReader = useCallback((value) => {
    audioManager.setBgmReaderEnabled(value);
    sync();
  }, [sync]);

  const setSFX = useCallback((value) => {
    audioManager.setSFXEnabled(value);
    sync();
  }, [sync]);

  return {
    muted: prefs.muted,
    bgmBiome: prefs.bgmBiome,
    bgmReader: prefs.bgmReader,
    sfxEnabled: prefs.sfxEnabled,
    toggleMute,
    setBgmBiome,
    setBgmReader,
    setSFX,
  };
}
